<template>
<div class="chapter">
<div class="inner_page">
<h1 class="calibre2" id="pgepubid00000">THE FRONTIER</h1>
<h2 class="calibre4 sigil_not_in_toc" id="pgepubid00002">MAURICE LEBLANC</h2>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Section0001.vue?4d9111ef